// Get environment variables (these are replaced by webpack DefinePlugin at build time)
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const DOMANYS_SECTRET_KEY = process.env.DOMANYS_SECTRET_KEY || '';

function validateEnvironmentVariables() {
  if (process.env.NODE_ENV === 'production') {
    const missingVars: string[] = [];
    
    if (!REACT_APP_API_BASE_URL) {
      missingVars.push('REACT_APP_API_BASE_URL');
    }
    
    if (!DOMANYS_SECTRET_KEY) {
      missingVars.push('DOMANYS_SECTRET_KEY');
    }
    
    if (missingVars.length > 0) {
      throw new Error(`Missing required environment variables for production: ${missingVars.join(', ')}`);
    }
  }
}

// Validate environment variables on module load
validateEnvironmentVariables();

export const CONFIG = {
  BASE_URL_API: REACT_APP_API_BASE_URL,
  APP_MODE: process.env.NODE_ENV || 'development',
  ADMIN_FAKE_DATA: process.env.REACT_APP_FAKE_DATA_ADMIN || '',
  DAF_FAKE_DATA: process.env.REACT_APP_FAKE_DATA_DAF || '',
  GTI_FAKE_DATA: process.env.REACT_APP_FAKE_DATA_GTI || '',
  FAKE_DATA: [process.env.REACT_APP_FAKE_DATA_ADMIN || '', process.env.REACT_APP_FAKE_DATA_DAF || '', process.env.REACT_APP_FAKE_DATA_GTI || ''],
};
